import { clearBookingId, initializeCollectionInfo, setFlowType } from "@/store/cashRegisterReducers/cashRegisterSlice"
import {
  setOpenModalCashRegisterWithAppointment,
  setOpenModalCashRegisterWithoutAppointment,
} from "@/store/modalsReducers/modalSlice"
import { useAppDispatch } from "@/store/store"
import { Card } from "@okeys/shared-react-components"
import { CardContent } from "../ui/card"

export const CashRegisterConnected = () => {
  const dispatch = useAppDispatch()

  const handleServiceWithoutAppointment = () => {
    dispatch(setFlowType("withoutBooking"))
    dispatch(setOpenModalCashRegisterWithoutAppointment({ isOpen: true }))
    dispatch(initializeCollectionInfo("validateService"))
  }

  const handleServiceWithAppointment = () => {
    dispatch(setFlowType("withBooking"))
    dispatch(initializeCollectionInfo())
    dispatch(clearBookingId())
    dispatch(setOpenModalCashRegisterWithAppointment({ isOpen: true }))
  }
  return (
    <CardContent className="flex-1 px-0 pt-2 flex ">
      <div className="flex-1 flex flex-row gap-6 w-full">
        <div className="flex flex-col gap-6 min-w-1/2">
          <Card
            onClick={handleServiceWithoutAppointment}
            withShadowHover
            className="flex-1 flex justify-center items-center"
          >
            <div className="text-center">
              <p className="text-muted-foreground text-sm leading-relaxed">
                Cliquez pour encaisser prestations
              </p>
              <h3 className="text-xl font-bold mb-2">Sans RDV</h3>
            </div>
          </Card>

          {/* Prestation avec RDV */}
          <Card
            onClick={handleServiceWithAppointment}
            withShadowHover
            className="flex-1 flex justify-center items-center"
          >
            <div className="text-center">
              <p className="text-muted-foreground text-sm leading-relaxed">
                Cliquez pour encaisser prestations
              </p>
              <h3 className="text-xl font-bold mb-2"> Avec RDV</h3>
            </div>
          </Card>
        </div>
        <div className="flex-1 flex flex-col gap-6">
          <Card onClick={handleServiceWithoutAppointment} className="flex-1">
            <div className="text-center">
              <p className="text-muted-foreground text-sm leading-relaxed">
                Encaisser prestations
              </p>
              <h3 className="text-xl font-bold mb-2">Sans RDV</h3>
            </div>
          </Card>
        </div>
      </div>
    </CardContent>
  )
}
